var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLolLightMode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.485 2.083H4.472L5.79 3.93v12.137l-1.583 1.847h11.345l1.847-2.639H9.485V2.083z",
    fill: "#D29E3E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.736 5.356a7.363 7.363 0 00-2.111 5.17c0 2.008.801 3.83 2.102 5.161l.009-.01v-1.65a6.303 6.303 0 01-1.056-3.5c0-1.296.389-2.5 1.056-3.502V5.356zM15.156 14.22A6.333 6.333 0 0010.54 4.216V3.157a7.388 7.388 0 015.872 11.063h-1.256z",
    fill: "#D29E3E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.78 14.22a5.277 5.277 0 00-3.24-8.945v8.945h3.24z",
    fill: "#D29E3E"
  })));
}
export default __webpack_public_path__ + "static/svg/lol-light-mode.svg";
export { SvgLolLightMode as ReactComponent };